import { NoteLink } from '@/modules/notes/components/NoteText';
import { findDroppedLinks, toNoteHref } from '@/modules/notes/noteLinks';

interface DroppedNoteLinksProps {
  original: string;
  polished: string;
}

/**
 * The AI polish (ai-services polish_prescreen_notes) rewrites the note and can
 * drop URLs, so links from the original stay reachable under the polished text.
 */
export const DroppedNoteLinks = ({
  original,
  polished,
}: DroppedNoteLinksProps) => {
  const urls = findDroppedLinks(original, polished);
  if (urls.length === 0) return null;

  return (
    <div className="space-y-1">
      <p className="text-muted-foreground text-xs">
        Links from the original note
      </p>
      <ul className="space-y-1 text-sm break-all">
        {urls.map((url) => (
          <li key={url}>
            <NoteLink href={toNoteHref(url)}>{url}</NoteLink>
          </li>
        ))}
      </ul>
    </div>
  );
};
